<div class="bottom-sheet">
  <div> {{ message }} </div>
  <button mat-button class="confirm" type="button" color="warn" (click)="confirm()">{{ 'CONFIRM.YES' | translate }} </button>
  <button mat-button class="cancel" type="button" color="warn" (click)="cancel()">{{ 'CONFIRM.NO' | translate }}</button>
</div>